

import moment from 'moment';
import useAppState from '../../context/AppContext';
import RecapElement from './RecapElement';
import { useNavigate } from 'react-router-dom';
import { relationType } from '../../context/model';
import { isPropositionInDraft } from '../../utils/dataUtils';
import ButtonModifyRecapInfo from '../common/ButtonModifyRecapInfo';
import { formatDateFR, formattedAttachmentOrganization, formattedNir } from '../../utils/utils';

interface RecapBeneficiaryFormComponentProps {
    modifyUrl: string
}

export default function RecapBeneficiaryFormComponent({ modifyUrl }: Readonly<RecapBeneficiaryFormComponentProps>) {
    const {
        state: { proposition, updatedProposition },
      
      } = useAppState();

    const navigate = useNavigate();

  return (
    <div>
        {
            updatedProposition!.beneficiaries 
            && updatedProposition!.beneficiaries.length > 0 
            && 
                <div className="flex-grid bg-blanc shadow-noir p-md mt-lg m-lg-desktop">
                    <div className="grid-flex wrapper-edition ">
                        <h2 className="card-title bleu mb-sm">
                            Mes ayants droit
                        </h2>

                        <ButtonModifyRecapInfo 
                            isDisplayed={proposition && isPropositionInDraft(proposition)}
                            handleClick={ () => navigate({ pathname: modifyUrl, search: `?id=${proposition!.propositionId}`, }) }
                        />

                    </div>  
                    {updatedProposition?.beneficiaries!.map((beneficiary, i) => 
                    <form key={i}>
                        <h1 className='card-title mt-sm mb-xs'>{beneficiary.relationType === relationType.CONJOINT ? 'Conjoint(e)' : beneficiary.relationType === relationType.CONCUBIN ? "Concubin(e)" : 'Enfant'} - {beneficiary.contact.lastName}  {beneficiary.contact.firstName}</h1>
                        <div className="form-row">      
                            <div className="form-group mw-33">
                                <RecapElement id='birthDate' label='Date de naissance' value={`${beneficiary.contact.birthDate ? formatDateFR(beneficiary.contact.birthDate) : ""}`} />
                            </div>
                            <div className="form-group mw-33">
                                <RecapElement id='nir' label='Numéro de sécurité sociale' value={`${beneficiary.contact.nir ? formattedNir(beneficiary.contact.nir) : "" } ${beneficiary.contact.nirKey}`} />
                            </div>
                            <div className="form-group mw-33">
                                <RecapElement id='attachmentOrganization' label='Organisme de rattachement' value={`${beneficiary.contact.attachmentOrganization? formattedAttachmentOrganization(beneficiary.contact.attachmentOrganization) : ''}`} />
                            </div>
                        </div> 
                    </form>
                    )}
                </div>
        } 
    </div>
)
}
